import { useEffect, useState } from "react";
import { Box, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

const StepTransportation = ({ updateInsuranceTranspor }) => {
    const storedData = useSelector(state => state.profiles.Transportation);
    const { t } = useTranslation();
    const [transportation, setTransportation] = useState({
        DoesClientHaveTransportation: "",
        pleasedescribeclient: "",
    });


    useEffect(() => {
        setTransportation(() => ({
            ...storedData
        }));
    }, [storedData]);

    const handleChange = async(field, value) => {
        setTransportation((prevData) => ({
            ...prevData,
            [field]: value
        }));
    };

    const handleNextStep = async (field, value) => {
        await handleChange(field, value); // 🔹 Espera que termine antes de seguir
        updateInsuranceTranspor({ Transportation: transportation });
    };

    return (
        <>
            <Typography variant="h6" gutterBottom>
                {t("Profiles.Transportation.Transportation")}
            </Typography>
            <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-start" }}>
                <FormControl component="fieldset" margin="normal">
                    <FormLabel component="legend">{t("Profiles.Transportation.Doesclienthaveaccesstotransportation?")} </FormLabel>
                    <RadioGroup row value={transportation.DoesClientHaveTransportation} onChange={(e) => handleNextStep("DoesClientHaveTransportation", e.target.value)}>
                        <FormControlLabel value="yes" control={<Radio />} label={t("Profiles.Yes")} />
                        <FormControlLabel value="no" control={<Radio />} label={t("Profiles.No")} />
                    </RadioGroup>
                </FormControl>
            </Box>   
            {transportation.DoesClientHaveTransportation === "no" && (
                <TextField 
                    fullWidth 
                    label={t("Profiles.Transportation.Ifno,pleasedescribeclient’s")}
                    margin="normal"
                    value={transportation.pleasedescribeclient}
                    onChange={(e) => handleNextStep("pleasedescribeclient", e.target.value)}
                />
            )}
        </>
    );
};

export default StepTransportation;
